// Structural data only. All human-readable text (title, descriptions, program
// details) lives in the `services` i18n namespace, keyed by `slug`
// (public/locales/{lng}/services.json).
const Services = [
  {
    Id: "01",
    sImg: "/Dar-Attaoui/Services/1.jpeg",
    sSImg: "/Dar-Attaoui/Services/1.jpeg",
    slug: "Quran-Memorization",
  },
  {
    Id: "02",
    sImg: "/Dar-Attaoui/Services/2.jpeg",
    sSImg: "/Dar-Attaoui/Services/2.jpeg",
    slug: "Tajweed-Rules",
  },
  {
    Id: "03",
    sImg: "/Dar-Attaoui/Services/3.jpeg",
    sSImg: "/Dar-Attaoui/Services/3.jpeg",
    slug: "Rasm-Dabt",
  },
  {
    Id: "04",
    sImg: "/Dar-Attaoui/Services/4.jpeg",
    sSImg: "/Dar-Attaoui/Services/4.jpeg",
    slug: "Islamic-Sciences-Project",
  },
];

export default Services;
